import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Button, useMediaQuery } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Container from "../../Components/Layout/Container";

import PaymentDetails from "../../Components/Checkouk/PaymentDetails";
import Summary from "../../Components/Checkouk/Summary";
import Heading from "../../Components/Common/Heading";
import CardsSlider from "../../Components/Common/CardSlider";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { useTheme } from "@emotion/react";
import { theme } from "../../Assets/Theme/theme";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { CurrencyContext } from "../../Services/CurrencyContext";
import { useCart } from "../../Services/CartContext";

function Checkout() {
  const location = useLocation();
  const bookingData = location.state?.bookingData;
  const formData = location.state?.formData;

  const { currency } = useContext(CurrencyContext);
  const themes = useTheme();
  const [loading, setLoading] = useState(true);
  const [experiencesData, setExperiencesData] = useState([]);
  const isSmallScreen = useMediaQuery(themes.breakpoints.down("sm"));

  const handleBackClick = () => {
    window.history.back();
  };

  const fetchExperiences = async (selectedCurrency) => {
    setLoading(true);
    try {
      const loginData = JSON.parse(localStorage.getItem("loginData"));
      const token = loginData?.token;

      const response = await axios.post(
        `${BASE_URL}/user/experiences`,
        { currencysymbol: selectedCurrency },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (Array.isArray(response.data?.data)) {
        setExperiencesData(response.data.data);
      } else {
        console.error("Unexpected data format: `data` is not an array");
        setExperiencesData([]);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.error("Error fetching experiences:", error?.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExperiences(currency);
  }, [currency]);

  return (
    <>
      <Navbar currency={currency} />{" "}
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mt: 4 }}>
          {/* Back Button */}
          <Button
            onClick={handleBackClick}
            sx={{
              color: theme.colors.textLight,
              minWidth: "auto",
              padding: "8px",
              marginLeft: isSmallScreen ? "10px" : "40px",
            }}
          >
            <ArrowBackIcon />
          </Button>
          {/* Heading */}
          <Box sx={{ flexGrow: 1, textAlign: "center" }} mt={3}>
            <Heading label={"Check Out"} />
          </Box>
        </Box>
        <Container>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Grid container spacing={4}>
                <Grid item xs={12} md={8}>
                  <PaymentDetails data={bookingData} step2Data={formData} />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Summary  />
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box mt={10}>
            <Heading label={"Related Experience"} />
          </Box>
          <CardsSlider data={experiencesData} />
        </Container>
      </Box>
      <Footer />
    </>
  );
}

export default Checkout;